import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";
import Swal from "sweetalert2";
import { ClipLoader } from 'react-spinners';
import '../Courses/Courses.css';
import { useNavigate } from "react-router-dom";
import { getCurrentDate } from "../Components/DateFunction";
import PDFViewer2 from "../PdfViewer";

const Notes = () => {
    const [dataSource, setDataSource] = useState([]);
    const [moduleId] = useState(localStorage.getItem('moduleId'));
    const [levelId] = useState(localStorage.getItem('levelId'));
    const [isAdmin, setIsAdmin] = useState(false);
    const [userId] = useState(localStorage.getItem('userId'));
    const [adminId] = useState(localStorage.getItem('Admin'));
    const [teacherId] = useState(localStorage.getItem('teacher'));
    const [freeTrial, setFreeTrial] = useState(localStorage.getItem('freeTrial') === 'true' ? true : false); // Convert to boolean
    const [title, setTitle] = useState('');
    const [author, setAuthor] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [file, setFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [hide, setHide] = useState(false);
    const [showPdfViewer, setShowPdfViewer] = useState(false);
    const [currentPdf, setCurrentPdf] = useState(null);

    const [promo] = useState(localStorage.getItem('PROMO'));

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setHide(true);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleSidebar = () => {
        setHide(prevHide => !prevHide);
    };

    useEffect(() => {
        if (localStorage.getItem('sd') !== "true") {
            navigate('/courses');
        }
    }, [navigate]);

    const handleShowModal = () => {
        setShowAddModal(true);
    };

    const fetchNotes = async () => {
        try {
            const response = await fetch(`${API_URL}/notes/mod/${moduleId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setDataSource(data);
        } catch (error) {
            console.error("Error fetching notes:", error);
        }
    };

    useEffect(() => {
        fetchNotes();
    }, []);

    const checkSub = async () => {

        //PROMO EDITION        
        if (promo === 'true') {
            console.log("Promo Edition active, no subscription check needed.");
            return
        }
        try {
            const response = await fetch(`${API_URL}/subscriptions/student/${userId}/${levelId}/${getCurrentDate()}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data.length < 1) {
                if (!freeTrial) {
                    navigate('/courses');
                }
            }
        } catch (error) {
            console.error("Error checking subscription:", error);
        }
    };

    useEffect(() => {
        const checkAdmin = () => {
            if ((localStorage.getItem('userRole') === "Admin") || userId === teacherId) {
                setIsAdmin(true);
            } else {
                checkSub();
            }
        };

        checkAdmin();
    }, [userId, adminId, teacherId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('module_id', moduleId);
            formData.append('title', title);
            formData.append('author', author);
            if (file) {
                formData.append('file', file);
            }

            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${API_URL}/notes/note`, true);
            xhr.setRequestHeader('Authorization', `Bearer ${token()}`);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    setShowAddModal(false);
                    Swal.fire({
                        text: "Notes uploaded successfully!",
                        icon: "success"
                    });
                    fetchNotes();
                    setTitle('');
                    setAuthor('');
                    setFile(null);
                } else {
                    throw new Error('Upload failed');
                }
                setIsLoading(false);
            };

            xhr.onerror = () => {
                Swal.fire({
                    text: "An error occurred!",
                    icon: "error"
                });
                setIsLoading(false);
            };

            xhr.send(formData);
        } catch (error) {
            Swal.fire({
                text: error.message || "An error occurred!",
                icon: "error"
            });
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            try {
                await fetch(`${API_URL}/notes/${id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                fetchNotes();
                Swal.fire({
                    text: "Deleted Successfully!",
                    icon: "success"
                });
            } catch (error) {
                Swal.fire({
                    text: "An error occurred while deleting!",
                    icon: "error"
                });
            }
        }
    };

    // const openPdf = (pdfUrl) => {
    //     // setCurrentPdf(`https://srv702611.hstgr.cloud:3012/file/spiritual_milk_for_the_new_believer.pdf`);
    //     setCurrentPdf(pdfUrl);
    //     setShowPdfViewer(true);
    // };

    const openPdf = (pdfUrl) => {
        const modifiedUrl = pdfUrl.replace('/download/', '/file/');
        setCurrentPdf(modifiedUrl);
        setShowPdfViewer(true);
    };

    return (
        <html lang="en">
            <body id="page-top">
                <div id="wrapper">
                    <Sidebar hide={hide}></Sidebar>

                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Topnav toggleSidebar={toggleSidebar}></Topnav>

                            <div className="container-fluid" style={{ textAlign: 'left', overflow: 'auto', maxHeight: '85vh' }}>
                                {!isAdmin ? (
                                    <h1 className="h3 mb-4 text-gray-800">Notes</h1>
                                ) : (
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        <h1 className="h3 mb-0 text-gray-800">Notes</h1>
                                        <button onClick={handleShowModal} className="d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                            <i className="fas fa-upload fa-sm text-white-50"></i> Upload Notes
                                        </button>
                                    </div>
                                )}

                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Notes Table</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table" id="dataTable" width="100%" cellSpacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>Title</th>
                                                        {/* <th>Author</th> */}
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataSource.map((element) => (
                                                        <tr key={element.notes_id}>
                                                            <td>{element.title}</td>
                                                            {/* <td>{element.author}</td> */}
                                                            <td>
                                                                {/* <a
                                                                    href={element.path}
                                                                    download
                                                                    className="text-primary mr-2"
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Download
                                                                </a> */}
                                                                {/* <span className="mx-2">|</span> */}
                                                                <button
                                                                    className="btn-link text-primary p-0 border-0 bg-transparent"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => openPdf(element.path)}
                                                                >
                                                                    View
                                                                </button>
                                                                &nbsp; <a href={element.path}> Download</a>
                                                                {isAdmin && (
                                                                    <>
                                                                        <span className="mx-2">|</span>
                                                                        <button
                                                                            className="btn-link text-danger p-0 border-0 bg-transparent"
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleDelete(element.notes_id)}
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showAddModal && (
                    <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowAddModal(false)}>
                        <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title">Upload Notes</h5>
                                    <button type="button" className="close" onClick={() => setShowAddModal(false)}>&times;</button>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label className="modal-label">Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="modal-label">Author</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={author}
                                                onChange={(e) => setAuthor(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="modal-label">File</label>
                                            <input
                                                type="file"
                                                className="form-control-file"
                                                accept=".doc, .docx, .pdf, .txt, .ppt, .pptx"
                                                onChange={(e) => setFile(e.target.files[0])}
                                                required
                                            />
                                            <small className="form-text text-muted">Supported formats: .doc, .docx, .pdf, .txt, .ppt, .pptx</small>
                                        </div>
                                        {isLoading && (
                                            <div className="form-group mt-3">
                                                <div className="progress">
                                                    <div
                                                        className="progress-bar"
                                                        role="progressbar"
                                                        style={{ width: `${uploadProgress}%` }}
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    >
                                                        {uploadProgress}%
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Close</button>
                                        {isLoading ? (
                                            <button className="btn btn-primary" disabled style={{ width: '100px' }}>
                                                <ClipLoader size={20} color="#ffffff" />
                                            </button>
                                        ) : (
                                            <button type="submit" className="btn btn-primary">Upload</button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                {showPdfViewer && (
                    <PDFViewer2
                        pdfUrl={currentPdf}
                        show={showPdfViewer}
                        onHide={() => setShowPdfViewer(false)}
                    />
                )}
            </body>
        </html>
    );
};

export default Notes;